class Config {
    constructor(data) {
        // public
        this.apiHostPublic = data.API_HOST_PUBLIC;
        this.staticBucket = data.STATIC_BUCKET_NAME;
        this.awsRegion = data.AWS_REGION;
        this.paymentIntegration = data.PAYMENTS_INTEGRATION;

        // internal
        this.fePort = data.FE_PORT || 8086;
        this.apiHost = data.API_HOST;
        // Адрес сайта для ссылок приглашения и QR. Из заголовка запроса
        // его взять нельзя: nginx проксирует без `proxy_set_header Host`,
        // и до приложения доходит `localhost:8086` — именно он и попал
        // бы в напечатанный QR (найдено 16.10).
        this.siteOrigin = data.SITE_ORIGIN;
        // Сколько браузеру держать статику. На деве ноль: там пересборка
        // идёт по несколько раз в час, а имена файлов постоянные —
        // `main.js` и `main.css`, — и любой срок жизни показывал бы
        // тестировщику старую сборку. На проде имеет смысл час
        // для стилей и скриптов и месяц для картинок и шрифтов.
        //
        // Настоящее решение — версия в имени файла, тогда сроку можно
        // не ограничиваться (bod-knowledge findings/page-speed.md).
        this.staticMaxAge = parseInt(data.STATIC_MAX_AGE || '0', 10) || 0;
        this.staticMediaMaxAge = parseInt(data.STATIC_MEDIA_MAX_AGE || '0', 10) || 0;
        // Версия статики в адресе: `/v/<версия>/css/main.css`. Меняется
        // с каждой сборкой, поэтому такие адреса можно кэшировать
        // надолго — после выката браузер просто просит другой адрес
        // и залипшего css не бывает. Без переменной берём время
        // запуска: контейнер пересоздаётся на каждом выкате.
        this.staticVersion = data.STATIC_VERSION || Date.now().toString(36);

        // computed
        this.staticDownloadPath = `https://${this.staticBucket}.s3.${this.awsRegion}.amazonaws.com`;
    }

    expose() {
        return {
            API_HOST_PUBLIC: this.apiHostPublic,
            STATIC_BUCKET_NAME: this.staticBucket,
            AWS_REGION: this.awsRegion,
            PAYMENTS_INTEGRATION: this.paymentIntegration,
        };
    }
}

module.exports = {
    Config
};
